import { type AxiosError } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  AuthControllerApiFactory,
  type LoginInitiateResponseV1,
} from '@redteclab/api/clients/composition-service-loyalty'
import { type LoginInitiateRequestV1 } from '@redteclab/api/clients/composition-service-loyalty/models'

import { useGlooApi } from '../../../api/gloo/client-side/useGlooApi'
import { useGlobalConfigContext } from '../../../global-config/context/globalConfigContext'

type LoginInitiateRequest = {
  fcSolution: string
  userName: string
}

const getLoginInitiateRequestMutationKey = (): string => {
  return 'useLoginInitiateRequestMutation'
}

export const useApiSwrLoginInitiateRequestMutation = ({
  onError,
}: {
  onError: () => void
}): SWRMutationResponse<
  LoginInitiateResponseV1,
  AxiosError,
  string,
  LoginInitiateRequest
> => {
  const { tenantAndEnv } = useGlobalConfigContext()

  const client = useGlooApi(AuthControllerApiFactory)

  const fetcher = async (
    swrKey: string,
    data: {
      arg: LoginInitiateRequest
    },
  ): Promise<LoginInitiateResponseV1> => {
    const loginInitiateRequestV1: LoginInitiateRequestV1 = {
      email: data.arg.userName,
      fcSolution: data.arg.fcSolution,
    }

    const response = await client.authV1TenantLoginInitiatePost({
      fcSolutionVersion: 'V1',
      LoginInitiateRequestV1: loginInitiateRequestV1,
      Sae_Device_Type: 'browser',
      tenant: tenantAndEnv,
    })

    return response.data
  }

  return useSWRMutation(getLoginInitiateRequestMutationKey(), fetcher, {
    onError,
  })
}
